<template>
  <div id="app" :class="currentTheme">
    <!-- 登录页面内容 -->
    <div class="login-container" :class="{ 'hidden': isLoading }">
      <!-- 左侧背景区域 -->
      <div class="left-panel">
        <div class="logo">
          <div class="logo-icon">
            <i class="el-icon-success" style="color: #67C23A"></i>
          </div>
          <span class="logo-whale">YiBinCS</span><span class="logo-admin">Jz - Administrator</span>
        </div>
        <div class="left-content">
          <div class="desktop-illustration">
            <div class="desktop-screen">
              <div class="screen-item"></div>
              <div class="screen-item"></div>
              <div class="screen-item"></div>
            </div>
            <div class="plant"></div>
            <div class="pen-holder"></div>
          </div>
          <h2 class="slogan">{{ language.slogan }}</h2>
          <p class="sub-slogan">{{ language.subSlogan }}</p>
        </div>

        <!-- 曲线分割线 -->
        <div class="curve-divider">
          <svg viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M0,100 C18,330 240,40 80,120 L120,120 L180,0 L280,0 Z" fill="currentColor"></path>
          </svg>
        </div>
      </div>

      <!-- 右侧登录表单 -->
      <div class="right-panel">
        <div class="login-form">
          <div class="title" style="height: 40px;">
            <span style="color: var(--primary-color);font-size: 22px;font-weight: bold;">{{ language.welcomeTitle }}</span>
          </div>
          <div class="login-cont">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="language.passwordLogin" name="first">
                <el-form :model="loginForm" ref="loginForm" :rules="rules">
                  <el-form-item prop="username">
                    <el-input v-model="loginForm.username" autocomplete="off"
                      :placeholder="language.usernamePlaceholder" prefix-icon="el-icon-user-solid"
                      clearable @keyup.enter.native="handleEnter"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input type="password" v-model="loginForm.password" autocomplete="off"
                      :placeholder="language.passwordPlaceholder" prefix-icon="el-icon-lock"
                      show-password @keyup.enter.native="handleEnter"></el-input>
                  </el-form-item>

                  <div class="chose">
                    <el-checkbox v-model="checked">{{ language.rememberMe }}</el-checkbox>
                  </div>
                  <el-form-item>
                    <el-button style="background-color: #00557f;width: 100%;" type="primary"
                      @click="submitForm" :loading="isLoading">
                      <span style="font-size: 16px;">{{ isLoading ? language.loggingIn : language.loginButton }}</span>
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>

      <!-- 主题切换按钮 -->
      <button class="theme-toggle" @click="toggleTheme">
        {{ currentTheme === 'theme-light' ? '🌙🌙' : '☀☀️' }}
      </button>

      <!-- 语言切换按钮 -->
      <button class="lang-toggle" @click="toggleLanguage">中/En</button>
    </div>

    <!-- 全屏加载动画 -->
    <div v-show="isLoading" class="loading-overlay">
      <div class="loading-container">
        <!-- 动态图标动画 -->
        <div class="logo-animation">
          <div class="logo-icon animated">
            <div class="logo-part part1"></div>
            <div class="logo-part part2"></div>
            <div class="logo-part part3"></div>
          </div>
        </div>
        
        <!-- 进度条 -->
        <div class="progress-container">
          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: loadingPercentage + '%' }"></div>
          </div>
          <div class="progress-text">{{ loadingPercentage }}%</div>
        </div>
        
        <!-- 加载提示 -->
        <div class="loading-content">
          <div class="loading-text">{{ loadingText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getInfo, getRoleMenuById, getroleMenuTreeselectById, login} from "@/api/user.js";
import { Message } from 'element-ui';

export default {
  name: 'LoginApp',
  data() {
    return {
      // 当前主题
      currentTheme: 'theme-light',
      
      // 加载状态
      isLoading: false,
      loadingPercentage: 0,
      loadingText: '',
      
      // 语言包
      languages: {
        zh: {
          slogan: '欢迎使用数字云诊所',
          subSlogan: '输入您的个人账户密码开始使用!',
          welcomeTitle: '管理员账户',
          passwordLogin: '账密登录',
          usernamePlaceholder: '请输入管理员工号',
          passwordPlaceholder: '请输入管理员密码',
          rememberMe: '记住账户',
          loginButton: '登录',
          loggingIn: '登录中...',
          verifyingAccount: '验证账号密码中...',
          savingInfo: '账号验证成功，保存登录信息...',
          preparingRedirect: '登录信息验证成功，准备跳转...',
          loginSuccess: '登录成功',
          loginFailed: '登录失败'
        },
        en: {
          slogan: 'Welcome to Digital Cloud Clinic',
          subSlogan: 'Enter your personal account password to get started!',
          welcomeTitle: 'Administrator Account',
          passwordLogin: 'Password Login',
          usernamePlaceholder: 'Please enter admin ID',
          passwordPlaceholder: 'Please enter admin password',
          rememberMe: 'Remember me',
          loginButton: 'Login',
          loggingIn: 'Logging in...',
          verifyingAccount: 'Verifying account credentials...',
          savingInfo: 'Account verified, saving login information...',
          preparingRedirect: 'Login information verified, preparing to redirect...',
          loginSuccess: 'Login successful',
          loginFailed: 'Login failed'
        }
      },
      
      // 登录表单
      loginForm: {
        username: "",
        password: "",
        clientId: 'e5cd7e4891bf95d1d19206ce24a7b32e',
      },
      
      // 表单验证规则
      rules: {
        username: [{
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          },
          {
            min: 2,
            max: 11,
            message: "长度在2到11个字符",
            trigger: "blur"
          },
        ],
        password: [{
            required: true,
            message: "请输入密码",
            trigger: "blur"
          },
          {
            min: 6,
            max: 15,
            message: "长度在6到15个字符",
            trigger: "blur"
          },
        ]
      },
      
      checked: false,
      currentLanguage: 'zh',
      activeName: 'first'
    };
  },
  computed: {
    language() {
      return this.languages[this.currentLanguage];
    }
  },
  mounted() {
    // 初始化加载文本
    this.loadingText = this.language.verifyingAccount;
    // 检查是否已登录，如果已登录直接跳转
	const token = localStorage.getItem('token');
	if (token) {
	  this.$router.push('/home');
	  return;
	}
    // 检查本地存储的主题偏好
    const savedTheme = localStorage.getItem('preferred-theme');
    if (savedTheme) {
      this.currentTheme = savedTheme;
    }
    
    // 检查本地存储的语言偏好
    const savedLanguage = localStorage.getItem('preferred-language');
    if (savedLanguage) {
      this.currentLanguage = savedLanguage;
    }
  },
  methods: {
    // 登录方法
    async submitForm() {
      try {
        // 表单验证
        const valid = await this.$refs.loginForm.validate();
        if (!valid) {
          return;
        }

        // 显示加载状态
        this.isLoading = true;
        this.loadingPercentage = 0;
        this.loadingText = this.language.verifyingAccount;

        // 步骤1: 账号密码验证
        await this.updateLoadingStatus(30, this.language.verifyingAccount);
        
        const loginRes = await login(this.loginForm);

        if (loginRes.code !== 200) {
          this.updateLoadingStatus(100, `${this.language.loginFailed}: ${loginRes.message || '未知错误'}`);
          Message.error(loginRes.message || this.language.loginFailed);
          this.isLoading = false;
          return;
        }

        // 步骤2: 保存登录信息
        await this.updateLoadingStatus(60, this.language.savingInfo);
        this.saveLoginInfo(loginRes.data);

		// 验证token保存状态
		const savedToken = localStorage.getItem('token');
		if (!savedToken) {
		  throw new Error('登录信息保存失败');
		}
        // 步骤3: 准备跳转
        await this.updateLoadingStatus(80, this.language.preparingRedirect);

        // 延迟跳转，让用户看到成功状态
        setTimeout(() => {
          this.isLoading = false;
          this.$router.push({ path: '/' });
          Message.success(this.language.loginSuccess);
        }, 1000);

      } catch (error) {
        console.error('登录过程中出错:', error);
        this.updateLoadingStatus(100, `${this.language.loginFailed}: ${error.message}`);
        Message.error(this.language.loginFailed);
        this.isLoading = false;
      }
    },

    // 保存登录信息
    async saveLoginInfo(data) {
          return new Promise(async (resolve) => {
            // 保存token和client_id到sessionStorage
            if (data.access_token) {
              sessionStorage.setItem('access_token', data.access_token);
            }
            if (data.client_id) {
              sessionStorage.setItem('client_id', data.client_id);
            }

            // 关键修改：将access_token存入localStorage的token字段
            if (data.access_token) {
              localStorage.setItem('token', data.access_token);
            } else if (data.token) {
              // 如果返回中没有access_token，则使用token字段
              localStorage.setItem('token', data.token);
            } else {
              console.error('登录返回中没有token或access_token字段');
            }
            // 保存记住我状态
            if (this.checked) {
              localStorage.setItem('rememberMe', 'true');
              localStorage.setItem('username', this.loginForm.username);
            } else {
              localStorage.removeItem('rememberMe');
              localStorage.removeItem('username');
            }
            const info = await getInfo();
            localStorage.setItem('roleId',info.data.user.roles[0]?.roleId);
            localStorage.setItem('channelId',info.data.user.channelId);
            localStorage.setItem('username', info.data.user.nickName);
            localStorage.setItem('permissions', JSON.stringify(info.data.permissions));
            localStorage.setItem('roles', JSON.stringify(info.data.user.roles));
            // 添加短暂延迟确保存储完成
            setTimeout(resolve, 100);
          });
        },

    // 更新加载状态
    updateLoadingStatus(percentage, text) {
      return new Promise(resolve => {
        this.loadingPercentage = percentage;
        this.loadingText = text;
        setTimeout(resolve, 300); // 添加短暂延迟让用户看到进度变化
      });
    },

    // 回车键登录
    handleEnter() {
      this.submitForm();
    },

    // 主题切换
    toggleTheme() {
      this.currentTheme = this.currentTheme === 'theme-light' ? 'theme-dark' : 'theme-light';
      // 保存主题偏好
      localStorage.setItem('preferred-theme', this.currentTheme);
    },

    // 语言切换
    toggleLanguage() {
      this.currentLanguage = this.currentLanguage === 'zh' ? 'en' : 'zh';
      // 更新加载文本
      this.loadingText = this.language.verifyingAccount;
      // 保存语言偏好
      localStorage.setItem('preferred-language', this.currentLanguage);
    },

    handleClick(tab) {
      console.log('Tab clicked:', tab.name);
    }
  }
};
</script>

<style lang="less" scoped>
/* 主题变量定义 */
:root {
  --bg-color: #f5f7fa;
  --text-color: #333;
  --form-bg: #fff;
  --input-bg: #fff;
  --input-border: #dcdfe6;
  --primary-color: #409eff;
  --secondary-text: #909399;
  --curve-color: #409eff;
}

.theme-light {
  --bg-color: #f5f7fa;
  --text-color: #333;
  --form-bg: #fff;
  --input-bg: #fff;
  --input-border: #dcdfe6;
  --primary-color: #409eff;
  --secondary-text: #909399;
  --curve-color: #409eff;
}

.theme-dark {
  --bg-color: #1a1a1a;
  --text-color: #e6e6e6;
  --form-bg: #2d2d2d;
  --input-bg: #3d3d3d;
  --input-border: #555;
  --primary-color: #409eff;
  --secondary-text: #a0a0a0;
  --curve-color: #409eff;
}

#app {
  height: 100vh;
  background-color: var(--bg-color);
  color: var(--text-color);
  transition: all 0.3s ease;
  overflow: hidden;
}

/* 登录容器样式 */
.login-container {
  display: flex;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;
  
  &.hidden {
    opacity: 0;
    visibility: hidden;
  }
}

/* 全屏加载动画样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--form-bg);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.loading-container {
  text-align: center;
  max-width: 500px;
  width: 90%;
}

/* 动态图标动画 */
.logo-animation {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 40px;
  
  .logo-icon {
    display: inline-block;
    position: relative;
    width: 100px;
    height: 100px;
    
    .logo-part {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      transition: all 0.5s ease;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-timing-function: ease-in-out;
    }
    
    .part1 {
      background: #409EFF;
      top: 0;
      left: 0;
      animation-name: logoPart1;
    }
    
    .part2 {
      background: #67C23A;
      top: 0;
      right: 0;
      animation-name: logoPart2;
    }
    
    .part3 {
      background: #E6A23C;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      animation-name: logoPart3;
    }
  }
}

/* Logo动画关键帧 */
@keyframes logoPart1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-20px, -20px); }
}

@keyframes logoPart2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(20px, -20px); }
}

@keyframes logoPart3 {
  0%, 100% { transform: translate(-50%, 0); }
  50% { transform: translate(-50%, 20px); }
}

/* 进度条样式 */
.progress-container {
  margin-bottom: 30px;
  
  .progress-bar {
    width: 100%;
    height: 8px;
    background: #e4e7ed;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  
  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #409EFF, #67C23A);
    border-radius: 4px;
    transition: width 0.5s ease;
  }
  
  .progress-text {
    font-size: 18px;
    font-weight: bold;
    color: #409EFF;
  }
}

/* 加载内容样式 */
.loading-content {
  text-align: center;
  
  .loading-text {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #409EFF;
  }
}

/* 原有样式保持不变 */
.left-panel {
  flex: 1.5;
  position: relative;
  background: url("@/assets/images/loginbg.png") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(30, 60, 114, 0.85) 0%, rgba(42, 82, 152, 0.85) 100%);
    z-index: 1;
  }
}

.curve-divider {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 60px;
  z-index: 10;
  color: var(--form-bg);

  svg {
    width: 100%;
    height: 100%;
  }
}

.logo {
  position: absolute;
  top: 30px;
  left: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 2;
  font-size: 24px;
  font-weight: bold;
}

.logo-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);

  svg {
    width: 20px;
    height: 20px;
    color: white;
  }
}

.logo-whale {
  color: #fff;
  font-weight: 700;
}

.logo-admin {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.left-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
  max-width: 500px;
  padding: 0 20px;
}

.desktop-illustration {
  width: 280px;
  height: 180px;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  margin: 0 auto 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.desktop-screen {
  width: 85%;
  height: 65%;
  background: linear-gradient(145deg, #f0f2f5, #e1e5eb);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.screen-item {
  height: 100%;
  background: url("@/assets/images/logoBg.png") center/cover no-repeat;
  margin-bottom: 8px;
  border-radius: 2px;
}

.screen-item:nth-child(1) {
  width: 65%;
}

.screen-item:nth-child(2) {
  width: 75%;
}

.screen-item:nth-child(3) {
  width: 85%;
}

.plant,
.pen-holder {
  position: absolute;
  bottom: -12px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.plant {
  left: 40px;
  background: linear-gradient(145deg, #4caf50, #388e3c);
}

.pen-holder {
  right: 40px;
  background: linear-gradient(145deg, #2196f3, #1976d2);
}

.slogan {
  font-size: 28px;
  margin-bottom: 15px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.sub-slogan {
  font-size: 16px;
  opacity: 0.9;
  line-height: 1.5;
}

.right-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: var(--form-bg);
  position: relative;
}

.login-form {
  width: 100%;
  max-width: 380px;
  padding: 30px;
  background: var(--form-bg);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.title {
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: 600;
  text-align: center;
}

.login-cont {
  background-color: var(--form-bg);
  padding: 20px;
  border-radius: 12px;
}

.chose {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.theme-toggle {
  position: absolute;
  top: 20px;
  right: 80px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: var(--text-color);
  z-index: 10;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.1);
  }
}

.lang-toggle {
  position: absolute;
  top: 20px;
  right: 30px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: var(--text-color);
  z-index: 10;
  padding: 6px 12px;
  border-radius: 6px;
  background: rgba(64, 158, 255, 0.1);
  transition: background 0.3s;

  &:hover {
    background: rgba(64, 158, 255, 0.2);
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .left-panel {
    flex: 1.2;
  }

  .curve-divider {
    width: 40px;
  }
}

@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
  }

  .left-panel {
    flex: 1;
    padding: 60px 20px;
  }

  .curve-divider {
    width: 100%;
    height: 40px;
    top: auto;
    bottom: 0;

    svg {
      transform: rotate(0deg);
    }
  }

  .right-panel {
    flex: 1;
    padding: 40px 20px;
  }

  .desktop-illustration {
    width: 220px;
    height: 150px;
  }

  .slogan {
    font-size: 24px;
  }

  .sub-slogan {
    font-size: 14px;
  }

  .theme-toggle,
  .lang-toggle {
    position: fixed;
    top: 15px;
  }

  .theme-toggle {
    right: 70px;
  }

  .lang-toggle {
    right: 20px;
  }
}

@media (max-width: 480px) {
  .login-form {
    padding: 20px;
  }

  .title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .slogan {
    font-size: 20px;
  }

  .sub-slogan {
    font-size: 13px;
  }

  .logo {
    top: 20px;
    left: 20px;
    font-size: 20px;
  }

  .logo-icon {
    width: 28px;
    height: 28px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
}

/* Element UI 组件样式适配 */
.el-input {
  /deep/ .el-input__inner {
    background-color: var(--input-bg);
    color: var(--text-color);
    border-color: var(--input-border);
    border-radius: 8px;
    height: 44px;
    padding: 0 28px;
    transition: border-color 0.3s;

    &:focus {
      border-color: var(--primary-color);
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    }
  }
}

.el-tabs {
  /deep/ .el-tabs__item {
    color: var(--text-color);
    font-weight: 500;
  }

  /deep/ .el-tabs__active-bar {
    background-color: var(--primary-color);
  }
}

.el-button--primary {
  background: linear-gradient(135deg, var(--primary-color), #66b1ff);
  border: none;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s;

  &:hover {
    background: linear-gradient(135deg, #66b1ff, var(--primary-color));
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  }
}

.el-checkbox {
  /deep/ .el-checkbox__label {
    color: var(--text-color);
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-form {
  animation: fadeInUp 0.6s ease;
}

.left-content {
  animation: fadeInUp 0.8s ease;
}

.curve-divider {
  animation: slideInRight 0.8s ease;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.logo-icon {
  animation: bounceIn 1s ease;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>